'use client';

import { useTranslations } from 'next-intl';
import { ListPageHeader } from '@terra/ui-design-system';

export function SignalsPageHeader() {
  const t = useTranslations('proxy.signals.page');

  return <ListPageHeader title={t('title')} subtitle={t('subtitle')} />;
}
